import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

const payOtherCostsRequested = createAction('otherCosts/payRequested')
const payOtherCostsReceived = createAction('otherCosts/payReceived')
const payOtherCostsFailed = createAction('otherCosts/payFailed')

// REDUCER
export const initialState = {
  payLoading: false,
  paySuccess: false,
  paymentData: null
}

const otherCostsReducer = createReducer(initialState, {
  [payOtherCostsRequested.type]: (state) => {
    state.payLoading = true
    state.paySuccess = false
    state.paymentData = null
  },
  [payOtherCostsReceived.type]: (state, action) => {
    state.payLoading = false
    state.paySuccess = true
    state.paymentData = action.payload?.data ?? null
  },
  [payOtherCostsFailed.type]: (state, action) => {
    state.payLoading = false
    state.paymentData = null
    toast.error(action.payload.message)
  }
})

export default otherCostsReducer

// ACTIONS

export const payOtherCosts = () => (dispatch, getState) => {
  const currentState = getState()
  const id = gameIdSelector(currentState)
  dispatch(
    apiCallBegan({
      url: `games/${id}/end_of_year/pay_other_costs`,
      method: 'post',
      onStart: payOtherCostsRequested.type,
      onSuccess: payOtherCostsReceived.type,
      onError: payOtherCostsFailed.type
    })
  )
}

